import React, { useState, useEffect } from 'react';
import { FaGamepad } from 'react-icons/fa';
import { getSiteLogo } from '../../utils/siteLogo';

const BrandBadge = ({ size = 'sm' }) => {
    const [logoUrl, setLogoUrl] = useState(null);

    useEffect(() => {
        getSiteLogo().then(url => { if (url) setLogoUrl(url); });
    }, []);

    const iconSize = size === 'sm' ? 'w-5 h-5' : 'w-6 h-6';
    const imgSize = size === 'sm' ? 'h-8' : 'h-10';
    const bgClass = size === 'sm' ? 'rounded-full bg-blue-50 flex items-center justify-center' : 'rounded-full bg-blue-100 flex items-center justify-center';

    if (logoUrl) {
        return (
            <img src={logoUrl} alt="Logo" className={`${imgSize} object-contain`} style={{ marginLeft: '-2px' }} />
        );
    }

    return (
        <div className="flex items-center gap-1.5">
            <div className={`${iconSize} ${bgClass}`}>
                <FaGamepad className="text-blue-500 text-[8px]" />
            </div>
            <span className="text-xs text-gray-400">Fastlane Lv.</span>
        </div>
    );
};

export default BrandBadge;
